import { Tag } from 'antd';

type RenderPillOptions = {
  /** Allow multi-line labels (long incident statuses). */
  wrap?: boolean;
};

export function renderPill(
  label: string,
  color: string,
  options?: RenderPillOptions,
) {
  return (
    <Tag
      title={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        marginInlineEnd: 0,
        maxWidth: '100%',
        height: 'auto',
        whiteSpace: options?.wrap ? 'normal' : 'nowrap',
        wordBreak: options?.wrap ? 'break-word' : undefined,
        borderRadius: 9999,
        paddingInline: 10,
        paddingBlock: 4,
        fontWeight: 600,
        fontSize: 12,
        lineHeight: 1.25,
        color: '#191c1f',
        background: `${color}1A`,
        border: `1px solid ${color}33`,
      }}
      bordered={false}
    >
      {label}
    </Tag>
  );
}

/**
 * Prefer API dashboard stats when loaded. Missing status keys mean 0 (API omits
 * zeros); only fall back to client counts before the stats response arrives.
 */
export function resolveDashboardStatusCount(
  apiByStatus: Partial<Record<string, number>> | undefined,
  status: string,
  fallbackCount: number,
): number {
  if (apiByStatus) {
    return apiByStatus[status] ?? 0;
  }

  return fallbackCount;
}

export function buildSmoothPath(points: { x: number; y: number }[]): string {
  if (points.length < 2) {
    return '';
  }

  let path = `M${points[0]!.x.toFixed(2)},${points[0]!.y.toFixed(2)}`;

  for (let index = 1; index < points.length; index++) {
    path += ` L${points[index]!.x.toFixed(2)},${points[index]!.y.toFixed(2)}`;
  }

  return path;
}
